import * as THREE from 'three';
export class InfinityCurve extends THREE.Curve {
    constructor(scale = 18, z = 0) {
        super();
        this.scale = scale;
        this.z = z;
    }
    getPoint(t, optionalTarget = new THREE.Vector3()) {
        const a = this.scale;
        const angle = t * Math.PI * 2;
        const d = 1 + Math.sin(angle) ** 2;
        const z = this.z * (1 - Math.sin(angle * 2)) / 2;
        optionalTarget.set(a * Math.cos(angle) / d, a * Math.sin(angle) * Math.cos(angle) / d, 0);
        return optionalTarget;
    }
}
